import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StrategicBusinessDriversRoutingModule } from './strategic-business-drivers-routing.module';
import { StrategicBusinessDriversComponent } from './strategic-business-drivers.component';
import { DxDataGridModule, DxSelectBoxModule, DxTextBoxModule, DxCheckBoxModule, DxTagBoxModule, DxAutocompleteModule, DxRadioGroupModule } from 'devextreme-angular';
import { I18nModule } from 'app/shared/i18n/i18n.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

@NgModule({
  declarations: [StrategicBusinessDriversComponent],
  imports: [
    CommonModule,
    StrategicBusinessDriversRoutingModule,
    DxDataGridModule,
    I18nModule,
    ReactiveFormsModule,
    FormsModule,
    DxSelectBoxModule,
    DxTextBoxModule,
    DxCheckBoxModule,
    DxTagBoxModule,
    DxAutocompleteModule,
    DxRadioGroupModule
  ]
})
export class StrategicBusinessDriversModule { }
